import React from 'react'
import { usePostRequest } from '../../hooks/request'
import { ANIMAL_LIST } from '../../urls'
import { useMessage } from '../../hooks/message'
import AnimalForm from './AnimalForm'

export default function AnimalCreate({ onSuccess, onCancel, animalTypes, initialTypeId }) {
    const animalCreate = usePostRequest({ url: ANIMAL_LIST })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const formData = new FormData()

        // Add all fields to FormData (use camelCase, humps will convert to snake_case)
        formData.append('identificationNumber', data.identificationNumber)
        formData.append('gender', data.gender)
        formData.append('ageCategory', data.ageCategory || 'adult')
        formData.append('acquisitionType', data.acquisitionType || 'purchased')
        formData.append('animalType', data.animalType)
        formData.append('status', data.status || 'active')

        if (data.birthDate) {
            formData.append('birthDate', data.birthDate)
        }

        if (data.notes) {
            formData.append('notes', data.notes)
        }

        // Add disposal information if status is not 'active'
        if (data.status !== 'active') {
            if (data.disposalDate) {
                formData.append('disposalDate', data.disposalDate)
            }
            if (data.disposalReason) {
                formData.append('disposalReason', data.disposalReason)
            }
        }

        // Add sold price if status is 'sold'
        if (data.status === 'sold' && data.soldPrice) {
            formData.append('soldPrice', data.soldPrice)
        }

        if (data.image && data.image instanceof File) {
            formData.append('image', data.image)
        }

        const { success } = await animalCreate.request({
            data: formData
        })

        if (success) {
            showMessage('Ҳайвон муваффақиятли қўшилди', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Янги ҳайвон қўшиш</b>
            </h1>

            <AnimalForm
                loading={animalCreate.loading}
                onSubmit={onSubmit}
                onCancel={onCancel}
                animalTypes={animalTypes}
                initialValues={initialTypeId ? { animalType: initialTypeId } : {}}
            />
        </div>
    )
}
